<template>
  <div class="login-view align direction">
    <div class="login-view-header">
      VIP专享功能，登录以验证您的权益
    </div>
    <div class="login-button" @click="showLogin()">
      登录
    </div>
  </div>
</template>

<script>
  export default {
    methods: {
      showLogin() {
        this.$store.commit('WRITEOVERLAYSHOW', {status: true})
      }
    },
  }
</script>

<style lang="less" scoped>
  .login-view {
    width: 100%;
    height: 4rem;
    padding-top: 1rem;
    .login-view-header {
      font-size: .28rem;
      color:rgba(161,174,191,1);
      line-height: .40rem;
    }
    .login-button {
      width: 3rem;
      height: 1rem;
      background: rgba(42,137,244,1);
      border-radius: .08rem;
      text-align: center;
      line-height: 1rem;
      color: #fff;
      font-size: .36rem;
      margin-top: 0.6rem;
    }
  }
</style>